import { environment } from 'src/environments/environment';
import { ApiService } from './../api.service';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({providedIn: 'root'})
export class PdfService {

	constructor(
		private apiService: ApiService,
		private sanitizer: DomSanitizer

	) { }

	generatePDF(body) {
		const generatePDFUrl = environment.pdfGenerate + '/api/v1/generatepdfreports/';
		return this.apiService.post(generatePDFUrl, body);
	}
	generateLOR(tcId) {
		const generateLORURL = environment.pdfGenerate + '/api/v1/generatepdfreports/letterofregistration?TcId=' + tcId
		return this.apiService.getBlob(generateLORURL, 'application/pdf');
	}
	_downloadFile(data: any, fileName?: any) {
		let fileUrl;
		fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data));
		const a = document.createElement('a');
		a.href = fileUrl.changingThisBreaksApplicationSecurity;
		a.download = fileName ? fileName : 'Report.xls';
		document.body.appendChild(a);
		a.click();
	}
	generateInspectionReport(body) {
		const generatePDFUrl = environment.pdfGenerate + '/api/v1/generatepdfreports/generateinspectionreports/';
		return this.apiService.post(generatePDFUrl, body);
	}

	// inspectionReport(payload) {
	// 	const pdfUrl = `${environment.pdfGenerate}/api/v1/pdfgen/inspection?userName=${payload.userName}&role=${payload.role}&type=${payload.type}`;
	// 	return this.apiService.getBlob(pdfUrl, 'application/pdf');
	// }

	inspectionReport(payload) {
		const pdfUrl = `${environment.pdfGenerate}/api/v1/pdf/inspection?userName=${payload.userName}&role=${payload.role}&type=${payload.type}`;
		return this.apiService.getBlob(pdfUrl, 'application/pdf');
	}

	downloadCertificate(body) {
		const URL = environment.batchServiceUrl + '/api/v1/cert/certificate?for=smart';
		return this.apiService.post(URL, body)
	}

	isFilePDF(url){
		if(url.split('.')[1]=='pdf')
		{
          return true
		} else {
			return false;
		}
	}
}
